export default __webpack_public_path__ + "static/media/BB_27.834b3fe7.png";